/* istanbul ignore file */
import defaultReducers from '@plone/volto/reducers';

import solr from './solr';
import userdetails from './userdetails';
import solrcollection from './solrcollection';
import hiddenblocktypes from './hiddenblocktypes';
import newestcomments from './newest-comments';
import pins from './pins';

const reducers = {
  ...defaultReducers,
  solr,
  userdetails,
  solrcollection,
  hiddenblocktypes,
  newestcomments,
  pins,
};

export default reducers;
